// Copyright (c) 2017 Deere & Company

import File, {getDefaultState as getDefaultFileState} from './file';
import AuditRecordingClaim from './audit-recording-claim';
import t from 'tcomb';

const AuditRecording = t.struct({
    actualAuditDate: t.maybe(t.Number),
    auditNumber: t.String,
    auditResults: t.String,
    city: t.String,
    claims: t.list(AuditRecordingClaim, 'Claims'),
    file: File,
    leadAccount: t.String,
    leadAccountName: t.String,
    state: t.String
}, {
    name: 'AuditRecording',
    strict: true
});

export const getDefaultState = () => new AuditRecording({
    actualAuditDate: null,
    auditNumber: '',
    auditResults: '',
    city: '',
    claims: [],
    file: getDefaultFileState(),
    leadAccount: '',
    leadAccountName: '',
    state: ''
});

export default AuditRecording;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/audit-recording.js